export default "__VITE_ASSET__7cb720f1__"